import { apiBaseUrl } from "./config.api.baseUrl";

export const baseAccessoryIri = '/api/accessories';

// Create Get Request for Accessories
export const apiGetAccessories = async (userToken: string) => {
  const response = await apiBaseUrl(userToken).get("/api/accessories");

  return response.data;
};